// extracted by mini-css-extract-plugin
export var hidden = "_s7-0";